import React from "react";
import {
  Create,
  SimpleForm,
  CreateProps,
  FormDataConsumer,
  TextInput,
  required,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import WaveInput from "./components/WaveInput";
import RouteInput from "./components/RouteInput";
import DriversInput from "./components/DriversInput";
import ParentsInput from "./components/ParentsInput";
import SchoolInput from "./components/SchoolInput";
import NotificationTargetInput from "./components/NotificationTargetInput";

const NotificationCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Notifications", link: `/notifications` },
    { title: "Create", link: "" },
  ];

  const transform = async (data: any) => {
    switch (data.notificationTargetType) {
      case "bus_schedule":
        data.notificationTargetId = data.busScheduleId;
        break;
      case "route":
        data.notificationTargetId = data.routeId;
        break;
    }

    if (!data.driverIds) {
      data.driverIds = [];
    }

    if (!data.parentIds) {
      data.parentIds = [];
    }

    return data;
  };

  // const FormSerialize = ({ schoolId }: { schoolId: number }) => {
  //   const schoolIdField = useField("schoolId");
  //
  //   useEffect(() => {
  //     schoolIdField.input.onChange(schoolId);
  //     console.log("TEST 1");
  //   }, [schoolId]);
  //
  //   return <></>;
  // };

  const getInputBasedNotificationTarget = (type: string) => {
    switch (type) {
      case "school":
        return (
          <>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>

            <Grid item xs={4}>
              <SchoolInput />
            </Grid>
            <Grid item xs={8}></Grid>
          </>
        );
      case "bus_schedule":
        return (
          <>
            <Grid item xs={12}>
              <Typography variant="h6">Wave</Typography>
            </Grid>

            <Grid item xs={4}>
              <WaveInput />
            </Grid>
            <Grid item xs={8}></Grid>
          </>
        );
      case "route":
        return (
          <>
            <Grid item xs={12}>
              <Typography variant="h6">Wave</Typography>
            </Grid>

            <Grid item xs={4}>
              <WaveInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Route</Typography>
            </Grid>

            <Grid item xs={4}>
              <RouteInput />
            </Grid>
            <Grid item xs={8}></Grid>
          </>
        );
    }
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Notification</Typography>
      <Create transform={transform} {...props}>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          {/*<FormSerialize schoolId={schoolIdSelected} />*/}
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Notification Target</Typography>
            </Grid>

            <Grid item xs={4}>
              <NotificationTargetInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <FormDataConsumer>
              {({ formData, ...rest }) =>
                getInputBasedNotificationTarget(formData.notificationTargetType)
              }
            </FormDataConsumer>

            <Grid item xs={12}>
              <Typography variant="h6">Send to</Typography>
            </Grid>

            <Grid item xs={4}>
              <DriversInput />
            </Grid>
            <Grid item xs={4}>
              <ParentsInput />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <TextInput source="title" validate={required()} />
            </Grid>
            <Grid item xs={8} />

            <Grid item xs={12}>
              <TextInput
                source="body"
                multiline
                rows={3}
                validate={required()}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default NotificationCreate;
